/** How long the arena stays clear after a destroying totem hit, before the result card. */
export const DESTROYED_TOTEM_HOLD_MS = 3000;

const TICK_MS = 1000 / 60;

const TOTEM_FINALES = new Set(['TOTEM_DESTROYED', 'SUDDEN_DEATH_TOTEM']);

/** True when the match ended because a totem reached zero lives. */
export function totemFinale(cause: string | null | undefined): boolean {
  return typeof cause === 'string' && TOTEM_FINALES.has(cause);
}

/** The result card waits out the destroying hit. Other endings show at once. */
export function resultCardVisible(cause: string | null | undefined, elapsedMs: number): boolean {
  if (!totemFinale(cause)) return true;
  return elapsedMs >= DESTROYED_TOTEM_HOLD_MS;
}

/**
 * The sim freezes on the tick after the killing blast is spawned.
 * Wall-clock time keeps that blast's lethal and visual windows moving.
 */
export function finaleShownTick(
  stateTick: number,
  playingFinale: boolean,
  elapsedMs: number,
): number {
  if (!playingFinale) return stateTick;
  return stateTick + Math.max(0, elapsedMs) / TICK_MS;
}

/** Remembers the first frame a given totem finale was seen. */
export class FinaleClock {
  private key = '';
  private at = 0;

  elapsed(cause: string | null | undefined, resultTick: number | null, now: number): number {
    if (!totemFinale(cause) || resultTick === null) {
      this.key = '';
      return 0;
    }
    const key = `${resultTick}:${cause}`;
    if (key !== this.key) {
      this.key = key;
      this.at = now;
    }
    return Math.max(0, now - this.at);
  }
}
